import { paths } from 'config'
import { Loadable } from 'shared/components'
import { ModuleRoute } from 'shared/types'

const routes: ModuleRoute[] = [
  {
    path: paths.consents,
    admin: false,
    exact: true,
    component: Loadable({
      component: () => import('./pages/Consents'),
    }),
    layoutSettings: {},
  },
]

export default routes
